import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ErrorLogo from "../Assets/Images/Icons/somethingWentWrongError.svg";

import { useTranslation } from "react-i18next";
import { API_KEY, API_URL, IS_DEV } from "./utils";
import axios from "axios";
import { decrypt, encrypt } from "./bycrypt";

interface ErrorFallbackPageProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export const ErrorFallbackPage: React.FC<ErrorFallbackPageProps> = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();

  const [isSend, setIsSend] = useState(false);
  // Use Translation
  const { t } = useTranslation();

  // Use location
  const { pathname } = useLocation();

  // Use Ref
  const originalPathname = useRef(pathname);

  // Goto previous Page
  const goToBack = () => {
    navigate(-1);
  };

  const errorInfoAPI = async (data) => {
    try {
      axios.interceptors.request.use(async (config: any) => {
        config.baseURL = API_URL;
        config.headers = {
          ...config.headers,
          "Api-Key": API_KEY ? API_KEY : "",
          Accept: "application/json",
          // "X-Requested-With": "XMLHttpRequest",
          "Accept-Language": "en",
          "Access-Control-Allow-Origin": "*",
        };
        return config;
      });

      axios
        .post(`${API_URL}/error-info`, { data }, { withCredentials: true })
        .then((response) => {
          let result: any = {};
          try {
            result = JSON.parse(decrypt(response?.data));
          } catch (error) {
            console.log("error in response else handler decrypt editAthletes", error);
          }
          if (result?.success) {
            console.log("error info send successfully");
          } else {
            console.log("error info send failed.");
          }
          setIsSend(true);
        })
        .catch((e) => {
          setIsSend(true);

          console.log("error in send error info errorInfoAPI:", e);
        });
    } catch (error) {
      setIsSend(true);

      console.log("error :: api ::: 1456", error);
    }
  };

  useEffect(() => {
    if (error !== undefined && error !== null) {
      if (error && IS_DEV !== 0 && !isSend) {
        let errorDetails = {
          file: "Unknown file", // Default in case no file is found
          line: "Unknown line", // Default in case no line is found
        };
        if (error.stack) {
          const stackLines = error.stack.split("\n");

          // Match file, line, and column number from stack trace
          const match = stackLines[1].trim().match(/(.*):(\d+):(\d+)/); // Updated regex

          if (match) {
            errorDetails.file = match[1].replace("at", "").trim(); // Extract file path
            errorDetails.line = match[2]; // Extract line number
          }
          errorInfoAPI(
            encrypt(
              JSON.stringify({
                message: error?.message,
                file: errorDetails.file,
                line: errorDetails?.line,
                page_url: window.location.href,
                error: { message: error?.message, stack: error.stack },
              })
            )
          );
        } else {
          console.log("Error does not have a stack trace:", error);
        }
        const stackLines = error.stack?.split("\n");
      }
    }
  }, [error]);

  // Use Effect
  useEffect(() => {
    if (pathname !== originalPathname.current) resetErrorBoundary();
  }, [pathname, resetErrorBoundary]);

  return (
    <div className="text-center w-100 d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div>
        <div className="px-3 mb-4 header-logo">
          <img src={ErrorLogo} alt="header logo" className="img-fluid" onClick={(e) => navigate("/")} />
        </div>
        <h5 className="ff_rg mb-1 f18">{t("error.somethingWrong")}</h5>
        <p className="ff_rg f14">
          {t("error.thereWasProblem")}
          <span className="d-block ff_rg f14 mx-3">{t("error.pleaseRefresh")}</span>
        </p>
        <p className="ff_rg f14 mt-3 text-secondary">
          {t("error.somethingNot")} ?{" "}
          <span className="ff_md f14 text-dark">
            {t("error.contact")} :{" "}
            <Link className="ff_md f14 text-dark" to="mailto: support@companyname.com">
              support@companyname.com
            </Link>{" "}
          </span>
        </p>
        <button className="btn btn-primary text-uppercase fs-6 px-3 txt-white mt-3" onClick={() => goToBack()}>
          {t("error.goBack")}
        </button>
      </div>
    </div>
  );
};
